import { render, staticRenderFns } from "./AlimtalkList.vue?vue&type=template&id=02700a6e&scoped=true"
import script from "./AlimtalkList.vue?vue&type=script&lang=js"
export * from "./AlimtalkList.vue?vue&type=script&lang=js"
import style0 from "./AlimtalkList.vue?vue&type=style&index=0&id=02700a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02700a6e",
  null
  
)

export default component.exports